import { z } from 'zod';
import { defineEndpoint } from '../define';
import { AgentInfoSchema, MAX_SAMPLES_PER_BATCH, MachineSampleSchema } from './shapes';

export const PushSamplesBodySchema = z.object({
  agent: AgentInfoSchema,
  samples: z.array(MachineSampleSchema).min(1).max(MAX_SAMPLES_PER_BATCH),
});
export type PushSamplesBody = z.infer<typeof PushSamplesBodySchema>;

/**
 * Heartbeat + metrics from a machine agent. Auth: `Authorization: Bearer <machine token>`
 * (never Firebase). Re-sent samples (same ts) are ignored, so retries are safe.
 */
export const pushRunnerSamples = defineEndpoint({
  method: 'POST',
  path: '/v1/runner-agent/samples',
  params: z.object({}),
  query: z.object({}),
  body: PushSamplesBodySchema,
  response: z.object({ data: z.object({ accepted: z.number().int() }) }),
});
